import classNames from 'classnames';

import useCenteredStyles from 'components/CenteredContent/CenteredContentJSS';

import type { CenterAlignedContentProps } from './types';

const CenteredContent = function ({ className = '', children }: CenterAlignedContentProps) {
  const { content } = useCenteredStyles();

  return <div className={classNames(content, className)}>{children}</div>;
};

export default CenteredContent;
